import { useEffect } from "react";
import { createTrackingUtils } from "../index.js";
import useRouteName from "../../../hooks/useRouteName.js";
const MAIN_FUNNEL_ROUTES = [
    "searchresults",
    "searchresults-outbound",
    "searchresults-inbound",
    "flightdetails",
    "flightdetails-outbound",
    "flightdetails-inbound"
];
const INDEX_ROUTES = ["home"];
const utils = createTrackingUtils({
    name: "flights_feta_web_migration_web",
    defaultStage: 7,
    stages: {
        csrMainFunnel: 7,
        csrIndex: 8
    },
    goals: {},
    goalsWithValue: []
});
export default function useWebMigrationCSRStages() {
    const routeName = useRouteName();
    useEffect(() => {
        if (MAIN_FUNNEL_ROUTES.includes(routeName)) {
            utils.stages.csrMainFunnel();
        }
        else if (INDEX_ROUTES.includes(routeName)) {
            utils.stages.csrIndex();
        }
    }, [routeName]);
}
